(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mf-dren-offers"] && !Shopify.designMode) return;
  try {
    class MfDrenOffers extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.change = () => this.sync();
      this.addEventListener('change', this.change);
      this.sync();
    }
    disconnectedCallback(){
      this.removeEventListener('change',this.change);
      clearTimeout(this.retry);
    }
    sync(){
      let radio=this.querySelector('input:checked:not(:disabled)') || this.querySelector('input:not(:disabled)');
      if(!radio) return;
      radio.checked=true;
      const form=this.section.querySelector('form[data-type="add-to-cart-form"]');
      if(!form){
        this.retry=setTimeout(()=>this.sync(),150);
        return;
      }
      const id=form.querySelector('[name="id"]');
      if(id) id.value=radio.dataset.variant;
      let quantity=form.querySelector('[name="quantity"]');
      if(!quantity){
        quantity=document.createElement('input');
        quantity.type='hidden';
        quantity.name='quantity';
        form.append(quantity);
      }
      quantity.value=radio.dataset.quantity;
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
      const qty=parseInt(radio.dataset.quantity,10);
      document.dispatchEvent(new CustomEvent('mf-dren-offer-changed',{detail:{quantity:qty,total:radio.dataset.total,pack:radio.dataset.pack}}));
      this.querySelectorAll('[data-gift]').forEach((gift)=>{
        gift.classList.toggle('is-unlocked', qty >= parseInt(gift.dataset.threshold,10));
      });
    }
  }
  if(!customElements.get('mf-dren-offers')){
    customElements.define('mf-dren-offers',MfDrenOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mf-mag-offers"] && !Shopify.designMode) return;
  try {
    class MfMagOffers extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.change = () => this.sync();
      this.addEventListener('change', this.change);
      this.sync();
    }
    disconnectedCallback(){
      this.removeEventListener('change',this.change);
      clearTimeout(this.retry);
    }
    sync(){
      let radio=this.querySelector('input:checked:not(:disabled)') || this.querySelector('input:not(:disabled)');
      if(!radio) return;
      radio.checked=true;
      const form=this.section.querySelector('form[data-type="add-to-cart-form"]');
      if(!form){
        this.retry=setTimeout(()=>this.sync(),150);
        return;
      }
      const id=form.querySelector('[name="id"]');
      if(id) id.value=radio.dataset.variant;
      let quantity=form.querySelector('[name="quantity"]');
      if(!quantity){
        quantity=document.createElement('input');
        quantity.type='hidden';
        quantity.name='quantity';
        form.append(quantity);
      }
      quantity.value=radio.dataset.quantity;
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  if(!customElements.get('mf-mag-offers')){
    customElements.define('mf-mag-offers',MfMagOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mf-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mf-pack-selector')) {
    class MfPackSelector extends HTMLElement {
      connectedCallback() {
        this._tries = 0;
        this._onChange = (event) => {
          const radio = event.target && event.target.closest ? event.target.closest('input.mf-pack__input') : null;
          if (radio) this._apply(radio);
        };
        this._onShow = () => this._init();
        this.addEventListener('change', this._onChange);
        window.addEventListener('pageshow', this._onShow);
        this._init();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
        window.removeEventListener('pageshow', this._onShow);
        clearTimeout(this._timer);
      }

      get _section() {
        return this.closest('.shopify-section') || document;
      }

      get _idInput() {
        const form = this._section.querySelector('form[data-type="add-to-cart-form"]') || this._section.querySelector('product-form-component form');
        return form ? form.querySelector('input[name="id"]') : null;
      }

      _init() {
        const radios = Array.from(this.querySelectorAll('input.mf-pack__input'));
        const radio = radios.find((r) => r.checked && !r.disabled) || radios.find((r) => !r.disabled);
        if (!radio) return;
        radio.checked = true;
        if (!this._apply(radio) && this._tries++ < 40) {
          clearTimeout(this._timer);
          this._timer = setTimeout(() => this._init(), 150);
        }
      }

      _apply(radio) {
        const input = this._idInput;
        if (!input) return false;
        const id = radio.dataset.variantId;
        if (input.value !== id) {
          input.value = id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this._syncAccelerated(radio);
        this._syncSticky(radio);
        this.dispatchEvent(new CustomEvent('mf-pack:change', { bubbles: true, detail: { variantId: id } }));
        return true;
      }

      _syncAccelerated(radio) {
        const accelerated = this._section.querySelector('shopify-accelerated-checkout');
        if (!accelerated) return;
        const id = radio.dataset.variantId;
        try {
          const list = JSON.parse(accelerated.getAttribute('variant-params') || '[]');
          if (Array.isArray(list) && !list.some((item) => String(item.id) === String(id))) {
            list.push({ id: Number(id), requiresShipping: radio.dataset.requiresShipping !== 'false' });
            accelerated.setAttribute('variant-params', JSON.stringify(list));
          }
        } catch (error) {
          /* sin cambios si el atributo no se puede leer */
        }
      }

      _syncSticky(radio) {
        const bar = this._section.querySelector('sticky-add-to-cart');
        if (!bar) return;
        const title = bar.querySelector('.sticky-add-to-cart__title');
        if (title) title.textContent = radio.dataset.title;
        const variant = bar.querySelector('.sticky-add-to-cart__variant');
        if (variant) variant.style.display = 'none';
        this._setMoney(bar.querySelector('.price'), radio.dataset.price);
        this._setMoney(bar.querySelector('.compare-at-price'), radio.dataset.compare);
      }

      _setMoney(el, value) {
        if (!el) return;
        el.style.display = value ? '' : 'none';
        if (!value) return;
        const nodes = Array.from(el.childNodes).filter((n) => n.nodeType === 3 && n.textContent.trim());
        if (nodes.length) nodes[nodes.length - 1].textContent = value;
        else el.append(value);
      }
    }
    customElements.define('mf-pack-selector', MfPackSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
